<template>
	<div>
		<v-row
			justify = "center"
			align   = "center"
		>
			<v-col
				xl 	 = "12"
				lg 	 = "12"
				md 	 = "12"
				sm 	 = "12"
				xs 	 = "12"
				cols = "12"
			>
			<v-card outlined>
				<v-card-title
					class = "secondary pa-1 body-1 white--text"
				>
					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>
					
					<v-spacer></v-spacer>

					<v-icon
						small
						:color = "head.title1 === 'face' ? 'primary' : head.title1 === 'lpr' || head.title1 === 'parking' ? 'warning' : 'success'"
						:icon = "head.title1 === 'face' ? 'mdi-face-recognition' : head.title1 === 'lpr' || head.title1 === 'parking' ? 'mdi-car' : 'mdi-format-list-bulleted-type'"
						class  = "mx-1"
					></v-icon>

					<span
						v-text = "$ml.get(head.title)"
					></span>
					<v-chip 
						x-small 
						:color = "head.title1 === 'face' ? 'primary' : head.title1 === 'lpr' || head.title1 === 'parking' ? 'warning' : 'success'"
						class  = "mx-2 text-uppercase"
						v-show = "head.title1"
					>  
						{{ route_type /*head.title1*/ }} 
					</v-chip>


					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text
					class = "pa-1 mt-1"
				>
					<v-row
						dense
					>
						<v-col
							cols = "12"
						>
							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary"
					    	>
					    		<v-toolbar-title 
					    			class = "body-2 white--text"
					    		>
					    			<v-icon
										small
										color = "white"
										class = "mr-1"
									>
										mdi-view-list
									</v-icon>
					    			{{ $ml.get('registered_list_details') }}
					    		</v-toolbar-title>
					    			<v-spacer></v-spacer>
					    			<v-btn
					    				x-small
					    				fab
					    				height = "25"
					    				width  = "25"
					    				color = "primary"
					    				@click = "openAddModal"
										v-show = "show.add_detail"

					    			>
					    			<v-icon>mdi-plus</v-icon>
					    			</v-btn>
					    	</v-toolbar>							
							<v-divider></v-divider>
							
							<!-- Formulario para agregar/editar registros -->
							<v-card v-show="show.add" outlined class="mt-2">
								<v-card-title class="primary white--text pa-2">
									<v-icon color="white" class="mr-2">mdi-plus-circle</v-icon>
									{{ sub_title }}
									<v-spacer></v-spacer>
									<v-btn icon @click="actions('show')" color="white">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</v-card-title>
								
								<v-card-text class="pa-2">
									<v-row dense>
										<template v-for="(field, index) in info_fields">
											<v-col cols="12" md="4" v-show="field.enable" :key="index">
												<!-- Campo de texto -->
												<v-text-field
													v-if="field.type === 'text'"
													dense
													outlined
													hide-details
													v-model="info[field.key]"
													:label="$ml.get(field.text)"
													:placeholder="$ml.get(field.text)"
													:error="isErrors[field.key]"
													:error-messages="messages[field.key]"
													class="mt-1"
													@input="clearError(field.key)"
												></v-text-field>
												
												<!-- Campo de selección -->
												<v-select
													v-else-if="field.type === 'select'"
													dense
													outlined
													hide-details
													v-model="info[field.key]"
													:label="$ml.get(field.text)"
													:items="render_listeds(field.list)"
													:item-text="field.item_text"
													:item-value="field.item_value"
													class="mt-1"
												></v-select>
												
												<!-- Campo MenuAutocompleteTrained -->
												<MenuAutocompleteTrained
													v-else-if="field.type === 'MenuAutocompleteTraineds'"
													:inputField="info"
													:keyField="field.key"
													:valueField="field.item_value"
													:valueText="field.item_text"
													:isReturnObject="field.return_obj"
													:isMultiple="field.isMultiple"
													:label="$ml.get(field.text)"
													:isDisabled="false"
													class="mt-1"
												></MenuAutocompleteTrained>
											</v-col>
										</template>
									</v-row>
								</v-card-text>
								
								<v-card-actions class="pa-2">
									<v-spacer></v-spacer>
									<v-btn color="secondary" @click="actions('show')">
										{{ $ml.get('cancel') }}
									</v-btn>
									<v-btn 
										color="primary" 
										@click="actions(btn_action)"
										:disabled="isRequiredInfo"
										:loading="loading"
									>
										<v-icon left>mdi-content-save</v-icon>
										{{ $ml.get(btn_action) }}
									</v-btn>
								</v-card-actions>
							</v-card>
							
							<v-data-table
								dense
							    fixed-body
							    fixed-header
								class 				 = "elevation-5"
								:items 				 = "render_list"
								:headers 			 = "header_table"
								:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	:loading-text 		 = "$ml.get('loading_please_wait')"
							   	:loading 			 = "loading"
							    item-key 			 = "id"
							    :height  			 = "layout_height + 'px'"
							   	:footer-props  		 = "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							>
							    <!-- rowsPerPageText: [30] -->
						      	<template v-slot:top>
							    	<v-row 
							    		no-gutters
							    	>
							    		<v-col
							    			xl 	 = "11"
							    			lg 	 = "11"
							    			md   = "10"
							    			sm   = "9"
							    			xs   = "8"
							    		cols = "8"
							    		>
							    			<searcher
												:info_to_component = "item_search"
												:info_to_list  	   = "list"
												@action_search 	   = "actions('search', $event)"
												@typing 		   = "search = $event"
											></searcher>
												<!-- @receive_info	   = "listed = $event" -->
							    		</v-col>
							    	
							    		<v-col
							    			xl 	 = "1"
							    			lg 	 = "1"
							    			md   = "2"
							    			sm   = "3"
							    			xs   = "4"
							    		cols = "4"
							    		v-show 	= "show.add_detail"
							    		>
							    			
							    			<!-- Botón de exportación con mismo estilo que importar -->
							    				<v-btn
													class="pa-0 success pl-0 pt-1 rounded-sm mb-2 export-btn-text"
													style="height: 40px; width: 100%; text-transform: none;"
													:loading="exporting"
													:disabled="exporting"
													@click="actions('export_excel')"
												>
													<v-icon left>mdi-download</v-icon>
													{{ $ml.get('import') === 'Import' ? $ml.get('export') : $ml.get('export').toLowerCase() }}
												</v-btn>
												<v-btn
													class="pa-0 primary pl-0 pt-1 rounded-sm mb-2 import-btn-text"
													style="height: 40px; width: 100%; text-transform: none;"
													@click="show.import_modal = true"
												>
													<v-icon left>mdi-file-excel</v-icon>
													{{ $ml.get('import') }}
												</v-btn>
							    				<!-- hide-input -->
							    			<!-- Remove old v-file-input for import here -->
							    			
						    			
							    		</v-col>
							    	</v-row>
							    </template>
								<template #item.actions="{ item }">								
									<v-btn
										x-small
										color  = "primary"
										@click = "actions('edit', item)"
										v-show = "show.edit_detail"
										class  = "mx-1"
									>
									<!-- $Helper.current_auth_user(this.currentUser, { roles : [1 , 2]}) -->
										<v-icon small>mdi-pencil</v-icon>
									</v-btn>
									<v-btn
										x-small
										color  = "error"
										@click = "actions('confirm_delete', item)"
										v-show = "show.delete_detail"
										class  = "mx-1"
									>
										<v-icon small>mdi-delete</v-icon>
									</v-btn>
								</template>

								<template #item.profile="{ item }">
									<v-chip 
										x-small
										:color = "item.profile && item.profile.name ? 'success' : 'secondary'"
									>
										{{ item.profile && item.profile.name ? item.profile.name : 'No Found'}} 
									</v-chip>
								</template>
								<template #item.in_lists="{ item }">
									<div v-if="item.listId">
										<v-chip
											x-small
											color="primary"
											class="ma-1"
											:title="`${item.list || getListName(item.listId)} - ${item.motive || 'No motive'}`"
										>
											<v-icon left x-small>mdi-format-list-bulleted</v-icon>
											{{ item.list || getListName(item.listId) }}
											<v-divider vertical class="mx-1"></v-divider>
											{{ item.motive || 'No motive' }}
										</v-chip>
									</div>
									<div v-else>
										<v-chip
											x-small
											color="grey"
										>
											<v-icon left x-small>mdi-close-circle</v-icon>
											{{ $ml.get('not_in_list') }}
										</v-chip>
									</div>
								</template>
								<template #item.name_entity="{ item, index }">
									<v-avatar>
									  <img
									    :src="$Helper.renderImageEntity(item)"
						         		@error = "item.urlImg = '/img/no_img_found.png'"
                						crossorigin=""
                						:key="'EntityFaceImg'+index+item.userId"
						         		:width  = "50" 
						         		:height = "50"						         											    
									  >
									</v-avatar>
									<span> {{ item.name_entity }}</span>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
			</v-col>
		</v-row>

		<!-- Modal para agregar entidades -->
	<v-dialog
		v-model="show.add_modal"
		max-width="1200px"
		persistent
	>
		<v-card>
			<v-card-title class="primary white--text">
				<v-icon color="white" class="mr-2">mdi-plus-circle</v-icon>
				{{ $ml.get('add_entities_to_list') }}
				<v-spacer></v-spacer>
				<v-btn
					icon
					@click="closeAddModal"
					color="white"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text class="pa-4">
				<!-- Descripción del Modal -->
				<v-alert
					type="info"
					text
					border="left"
					class="mb-4"
				>
					<v-icon left color="info">mdi-information</v-icon>
					<strong>{{ $ml.get('instructions') }}:</strong> {{ $ml.get('select_list_and_choose_entities') }}
				</v-alert>

				<!-- Selector de Lista y Motivo -->
				<v-row>
					<v-col cols="12" md="4">
						<v-select
							v-model="selected_list"
							:items="list_lists"
							item-text="name"
							item-value="id"
							:label="$ml.get('select_list')"
							outlined
							dense
							@change="onListChange"
							:color="selected_list ? 'success' : 'primary'"
							:prepend-icon="selected_list ? 'mdi-check-circle' : 'mdi-format-list-bulleted'"
						>
							<template v-slot:append>
								<v-icon v-if="selected_list" color="success">mdi-check</v-icon>
							</template>
						</v-select>
						<div v-if="!selected_list" class="text-caption text--secondary mt-1">
							<v-icon small left color="info">mdi-information</v-icon>
							{{ $ml.get('step_1_select_list_first') }}
						</div>
					</v-col>
					<v-col cols="12" md="4">
						<v-text-field
							v-model="motive"
							:label="$ml.get('motive')"
							outlined
							dense
							:placeholder="$ml.get('enter_motive')"
							:disabled="!selected_list"
							:color="motive && selected_list ? 'success' : 'primary'"
							:prepend-icon="motive && selected_list ? 'mdi-check-circle' : 'mdi-comment-text'"
						>
							<template v-slot:append>
								<v-icon v-if="motive && selected_list" color="success">mdi-check</v-icon>
							</template>
						</v-text-field>
						<div v-if="selected_list && !motive" class="text-caption text--secondary mt-1">
							<v-icon small left color="warning">mdi-alert</v-icon>
							{{ $ml.get('step_2_enter_motive') }}
						</div>
						<div v-else-if="!selected_list" class="text-caption text--secondary mt-1">
							<v-icon small left color="info">mdi-information</v-icon>
							{{ $ml.get('step_1_select_list_first') }}
						</div>
					</v-col>
					<v-col cols="12" md="4">
						<div v-if="selected_list && motive" class="text-center pa-2">
							<v-chip
								color="success"
								class="ma-2"
							>
								<v-icon left>mdi-check-circle</v-icon>
								{{ $ml.get('ready_to_select_entities') }}
							</v-chip>
															<p class="text-caption text--secondary mt-1">
									{{ $ml.get('step_3_select_faces') }}
								</p>
						</div>
						<div v-else-if="selected_entities.length > 0" class="text-center pa-2">
							<v-chip
								color="success"
								class="ma-2"
							>
								<v-icon left>mdi-check-circle</v-icon>
								{{ selected_entities.length }} {{ $ml.get('entities_selected') }}
							</v-chip>
							<p class="text-caption text--secondary mt-1">
								{{ $ml.get('entities_selected_for_list') }} ({{ Math.ceil(selected_entities.length / 100) }} {{ $ml.get('pages') }})
							</p>
						</div>
						<div v-else class="text-center pa-2">
							<p class="text-caption text--secondary">
								<v-icon small left color="grey">mdi-information</v-icon>
								{{ $ml.get('select_entities_from_table') }}
							</p>
						</div>
					</v-col>
				</v-row>

				<!-- Indicador de Progreso -->
				<v-divider class="my-4"></v-divider>
				<v-row class="mb-4">
					<v-col cols="12">
						<h6 class="text-h6 text--secondary mb-2">
							<v-icon left small color="primary">mdi-progress-clock</v-icon>
							{{ $ml.get('setup_progress') }}
						</h6>
						<v-stepper
							v-model="setup_step"
							alt-labels
							class="elevation-0"
						>
							<v-stepper-header class="elevation-0">
								<v-stepper-step
									:complete="!!selected_list"
									:rules="[() => !!selected_list]"
									step="1"
								>
									{{ $ml.get('select_list') }}
								</v-stepper-step>

								<v-divider></v-divider>

								<v-stepper-step
									:complete="!!(motive && selected_list)"
									:rules="[() => !!motive && !!selected_list]"
									step="2"
								>
									{{ $ml.get('enter_motive') }}
								</v-stepper-step>

								<v-divider></v-divider>

								<v-stepper-step
									:complete="!!(selected_entities.length > 0 && selected_list && motive)"
									:rules="[() => selected_entities.length > 0 && !!selected_list && !!motive]"
									step="3"
								>
									{{ $ml.get('select_faces') }}
								</v-stepper-step>
							</v-stepper-header>
						</v-stepper>
					</v-col>
				</v-row>

				<!-- Filtros -->
				<v-divider class="my-4"></v-divider>
				<v-row class="mb-2">
					<v-col cols="12">
						<h6 class="text-h6 text--secondary mb-2">
							<v-icon left small color="primary">mdi-filter</v-icon>
							{{ $ml.get('search_filters') }}
						</h6>
						<p class="text-caption text--secondary mb-0">
							{{ $ml.get('use_filters_to_find_entities') }}
						</p>
					</v-col>
				</v-row>
				<v-row class="mb-4">
					<v-col cols="12" md="4">
						<v-text-field
							v-model="filter_name"
							:label="$ml.get('filter_by_name')"
							outlined
							dense
							prepend-icon="mdi-account-search"
							@input="applyFilters"
							:disabled="!selected_list || !motive"
							:color="(selected_list && motive) ? 'primary' : 'grey'"
						></v-text-field>
						<div v-if="!selected_list || !motive" class="text-caption text--secondary mt-1">
							<v-icon small left color="info">mdi-information</v-icon>
							{{ $ml.get('complete_steps_1_and_2_first') }}
						</div>
					</v-col>
					<v-col cols="12" md="4">
						<v-menu
							ref="date_menu"
							v-model="date_menu"
							:close-on-content-click="false"
							transition="scale-transition"
							offset-y
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="filter_date"
									:label="$ml.get('filter_by_date')"
									outlined
									dense
									prepend-icon="mdi-calendar"
									readonly
									v-bind="attrs"
									v-on="on"
									@click="date_menu = true"
									:disabled="!selected_list || !motive"
									:color="(selected_list && motive) ? 'primary' : 'grey'"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="filter_date"
								@input="onDateChange"
								no-title
								scrollable
							></v-date-picker>
						</v-menu>
					</v-col>

					<v-col cols="12" md="4">
						<v-btn
							color="secondary"
							@click="clearFilters"
							class="mt-4"
							:disabled="!selected_list || !motive"
						>
							<v-icon left>mdi-filter-remove</v-icon>
							{{ $ml.get('clear_filters') }}
						</v-btn>
					</v-col>
				</v-row>

				<!-- Tabla de Entidades -->
				<v-divider class="my-4"></v-divider>
				<v-row class="mb-2">
					<v-col cols="12" md="8">
						<h6 class="text-h6 text--secondary mb-2">
							<v-icon left small color="primary">mdi-table</v-icon>
							{{ $ml.get('available_entities') }}
						</h6>
						<p class="text-caption text--secondary mb-0">
							{{ $ml.get('select_entities_to_add_to_list') }}
						</p>
					</v-col>
					<v-col cols="12" md="4" class="text-right">
						<v-btn
							:color="select_all_mode ? 'error' : 'primary'"
							:loading="loading_all_entities"
							@click="selectAllEntities"
							small
							class="mb-2"
						>
							<v-icon left>
								{{ select_all_mode ? 'mdi-close' : 'mdi-checkbox-multiple-marked' }}
							</v-icon>
							{{ select_all_mode ? $ml.get('deselect_all') : $ml.get('select_all') }}
						</v-btn>
						<div v-if="select_all_mode" class="text-caption text--secondary">
							<v-icon small left color="success">mdi-information</v-icon>
							{{ $ml.get('global_mode_activated') }} - {{ selected_entities.length }} {{ $ml.get('entities_of') }} {{ Math.ceil(selected_entities.length / 100) }} {{ $ml.get('pages') }}
							<div v-if="filter_name || filter_date" class="mt-1">
								<v-icon small left color="warning">mdi-filter</v-icon>
								<strong>{{ $ml.get('active_filters') }}:</strong>
								<span v-if="filter_name" class="ml-1">{{ $ml.get('name') }}: "{{ filter_name }}"</span>
								<span v-if="filter_date" class="ml-1">{{ $ml.get('date') }}: "{{ filter_date }}"</span>
							</div>
						</div>
					</v-col>
				</v-row>
				<div v-if="filtered_entities.length === 0 && !loading_entities" class="text-center pa-4">
					<v-icon size="64" color="grey lighten-1">mdi-account-group</v-icon>
					<h6 class="text-h6 text--secondary mt-2">{{ $ml.get('no_entities_available') }}</h6>
					<p class="text-caption text--secondary">
						{{ $ml.get('no_entities_match_search_criteria') }}
					</p>
				</div>
				<div class="position-relative">
					<v-data-table
						v-model="selected_entities"
						:items="filtered_entities"
						:headers="entity_headers"
						:loading="loading_entities"
						item-key="id"
						show-select
						:single-select="false"
						class="elevation-1"
						:height="400"
						:server-items-length="total"
						:options.sync="tableOptions"
						:footer-props="{
							showFirstLastPage: true,
							itemsPerPageOptions: [100, 200, 500],
							showCurrentPage: true,
							itemsPerPageText: ''
						}"
					>
					
					<!-- Overlay cuando la tabla está deshabilitada -->
					<template v-slot:top>
						<div v-if="!selected_list || !motive" class="table-overlay">
							<div class="overlay-content text-center">
								<v-icon size="64" color="grey lighten-1">mdi-lock</v-icon>
								<h6 class="text-h6 text--secondary mt-2">{{ $ml.get('table_locked') }}</h6>
								<p class="text-caption text--secondary">
									{{ $ml.get('complete_setup_steps_to_unlock') }}
								</p>
								<v-chip color="info" class="mt-2">
									<v-icon left>mdi-information</v-icon>
									{{ $ml.get('step') }} {{ setup_step }}/3
								</v-chip>
							</div>
						</div>
					</template>
					<template #item.photo="{ item }">
						<v-avatar size="50">
							<img
								:src="getEntityImage(item)"
								@error="item.urlImg = '/img/no_img_found.png'"
								crossorigin=""
								:width="50"
								:height="50"
							>
						</v-avatar>
					</template>

					<template #item.userName="{ item }">
						<strong>{{ item.userName || 'N/A' }}</strong>
					</template>

					<template #item.lists="{ item }">
						<div v-if="item.detail_lists && item.detail_lists.length > 0">
							<v-chip
								v-for="list in item.detail_lists"
								:key="list.id"
								x-small
								:color="list.listId == selected_list ? 'error' : 'warning'"
								class="ma-1"
								:title="`${getListName(list.listId)} - ${list.motive || 'No motive'}`"
							>
								<v-icon left x-small>
									{{ list.listId == selected_list ? 'mdi-alert-circle' : 'mdi-format-list-bulleted' }}
								</v-icon>
								{{ getListName(list.listId) }}
								<v-divider vertical class="mx-1"></v-divider>
								{{ list.motive || 'No motive' }}
								<v-icon v-if="list.listId == selected_list" right x-small color="white">mdi-check</v-icon>
							</v-chip>
						</div>
						<div v-else>
							<v-chip
								x-small
								color="grey"
								class="ma-1"
							>
								<v-icon left x-small>mdi-close-circle</v-icon>
								{{ $ml.get('not_in_list') }}
							</v-chip>
						</div>
					</template>

					<template #item.createdAt="{ item }">
						{{ formatDate(item.createdAt) }}
					</template>
					</v-data-table>
				</div>
			</v-card-text>

			<v-card-actions class="pa-4">
				<v-spacer></v-spacer>
				<v-btn
					color="secondary"
					@click="closeAddModal"
					class="mr-2"
				>
					{{ $ml.get('cancel') }}
				</v-btn>

				<v-btn
					color="primary"
					@click="addEntitiesToList"
					:disabled="selected_entities.length === 0 || !selected_list"
					:loading="adding_entities"
				>
					<v-icon left>mdi-plus</v-icon>
					{{ $ml.get('add_to_list') }} ({{ getEffectiveEntitiesCount() }})
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<!-- Import Modal -->
	<v-dialog v-model="show.import_modal" max-width="500px">
	  <v-card>
	    <v-card-title class="primary white--text">
	      <v-icon color="white" class="mr-2">mdi-file-excel</v-icon>
	      {{ $ml.get('import') }}
	      <v-spacer></v-spacer>
	      <v-btn icon @click="closeImportModal" color="white">
	        <v-icon>mdi-close</v-icon>
	      </v-btn>
	    </v-card-title>
	    <v-card-text class="pa-4">
	      <v-select
	        v-model="import_selected_list"
	        :items="renderLists"
	        item-text="name"
	        item-value="id"
	        :label="$ml.get('select_list')"
	        outlined
	        dense
	        :color="import_selected_list ? 'success' : 'primary'"
	        :prepend-icon="import_selected_list ? 'mdi-check-circle' : 'mdi-format-list-bulleted'"
	        class="mb-4"
	      ></v-select>
	      <v-alert type="info" text border="left" class="mb-4">
	        
	        <strong>Formato Excel:</strong> El archivo debe tener las siguientes columnas:
	        <v-simple-table class="mt-2" dense>
	          <thead>
	            <tr>
	              <th>placa</th>
	              <th>motivo</th>
	            </tr>
	          </thead>
	          <tbody>
	            <tr>
	              <td>ABC123</td>
	              <td>Motivo de ejemplo</td>
	            </tr>
	            <tr>
	              <td>XYZ789</td>
	              <td>Otro motivo</td>
	            </tr>
	          </tbody>
	        </v-simple-table>
	      </v-alert>
	      <v-file-input
	        v-model="info_import"
	        :prepend-icon="validating_file ? 'mdi-loading mdi-spin' : 'mdi-file-excel'"
	        :placeholder="validating_file ? $ml.get('validating_file') : $ml.get('select_file')"
	        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
	        outlined
	        dense
	        class="mb-4"
	        :disabled="validating_file"
	        @change="onFileSelected"
	      ></v-file-input>
	    </v-card-text>
	    <v-card-actions class="pa-4">
	      <v-spacer></v-spacer>
	      <v-btn color="secondary" @click="closeImportModal">
	        {{ $ml.get('cancel') }}
	      </v-btn>
	      <v-btn color="primary" :disabled="!info_import || !import_selected_list || loading" :loading="loading" @click="importExcelFromModal">
	        <v-icon left>mdi-upload</v-icon>
	        {{ $ml.get('import') }}
	      </v-btn>
	    </v-card-actions>
	  </v-card>
	</v-dialog>
	</div>
</template>
<script>
	import EventBus from '@/event-bus'
	import axios from 'axios'
	import searcher from "@/components/info/searcher.vue"
	import MenuAutocompleteTrained from "@/components/face/MenuAutocompleteTrained.vue"
	export default{
		name : 'listing_details',
		components  : {
			searcher, MenuAutocompleteTrained
		}, // components
		data : (vm) => ({
			info 	: {},
			head 	: {
				title  : 'listing_details',
				title1 : 'lpr',
			}, 
			isErrors :{ plate_char: false},
			messages : {plate_char : []},
			info_fields : [
				{
					key  : 'listId',
					text : 'list',
					type : 'select',
					list : 'renderLists',//list_lists
					enable : true,
					item_value  : 'id',
					item_text   : 'name'
 				},
				{
					key  : 'plate_char',
					text : 'plate_char',
					type : 'text',
					enable : true,
					isRule : false,
					
					
				},
				{
					key  : 'entity',
					text : 'entity',
					type : 'MenuAutocompleteTraineds',
					list : 'list_entity',
					enable : false,
					item_value : "userId",
					item_text  : "userName",
					return_obj : false,
					isMultiple : true,

				},

				{
					key  : 'motive',
					text : 'motive',
					type : 'text',
					enable : true,
				},
				{
					key  : 'profile',
					text : 'profile',
					type : 'select',					
					list : 'list_profiles',
					enable : false,
					value  : 'profileId',
					item_text   : 'name'
				},

			],
			show : {
				add 			: false,
				add_detail  	: true,
				edit_detail  	: true,
				delete_detail  	: true,
				add_modal 		: false,
				import_modal    : false, // control for import modal
			},
			sub_title : vm.$ml.get('register'),
			
			show_progress : false,
			btn_action 	  : 'save',
			header_table  : [
				{ text : vm.$ml.get('plate_char'), 	value : 'plate_char' },
				{ text : vm.$ml.get('motive'), 		value : 'motive' },
				{ text : vm.$ml.get('lists'), 		value : 'in_lists', align: 'center' },
				// { text : vm.$ml.get('profile'), 	value : 'profile' },
				{ text : vm.$ml.get('actions'), 	value : 'actions' },
			],
			options 	  : { itemsPerPage : 30 },
			total 		  : 0,
			layout_height : 400,
			ID_notification : 'listing_details',
			loading 	  : false,
			list_lists 	  : [],
			list 		  : [], 
			listed 	 	  : [],
			required_info : false,
			list_profiles : [],
			bus 		  : {}, 
			item_search   : {
				key 		 : 'search',
				text 		 : 'search',
				placeholder  : 'device',
				list 		 : 'list_devices',
				key_list	 : 'deviceId',
				text_list 	 : 'name',
				type 		 : 'field_searcher',
				key_search   : 'name',
				key_search_1 : 'deviceId',
				uppercase  	 : true,
				visible 	 : true,
				cols 		 : {
					col : 2,
				},
			},
			info_import : null,
			list_entity : [],
			search 		: "",
			exporting   : false,
			validating_file : false,

			// Modal de Entidades
			selected_list: null,
			selected_entities: [],
			motive: '',
			filtered_entities: [],
			all_entities: [], // Todas las entidades de todas las páginas
			filter_name: '',
			filter_date: null,
			date_menu: false,
			loading_entities: false,
			loading_all_entities: false, // Estado de carga para obtener todas las entidades
			select_all_mode: false, // Modo de selección global
			entity_headers: [
				{ text: 'photo', value: 'photo', align: 'center', sortable: false },
				{ text: 'name', value: 'userName' },
				{ text: 'lists', value: 'lists', align: 'center', sortable: false },
				{ text: 'date', value: 'createdAt' }
			],
			adding_entities: false,
			
			// Configuración de paginación del servidor
			tableOptions: {
				page: 1,
				itemsPerPage: 100, // Usar un límite alto para reducir el número de páginas
				sortBy: [],
				sortDesc: []
			},
			setup_step: 0, // Nuevo paso de configuración
			import_selected_list: null, // selected list for import
		}), // data

		created(){
			// Inicializar headers de la tabla de entidades
			this.entity_headers = [
				{ text: this.$ml.get('photo'), value: 'photo', align: 'center', sortable: false },
				{ text: this.$ml.get('name'), value: 'userName' },
				{ text: this.$ml.get('lists'), value: 'lists', align: 'center', sortable: false },
				{ text: this.$ml.get('date'), value: 'createdAt' }
			];
			
			this.render_created();
			this.get_listing();
			// this.get_profiles();
		}, // created

		watch : {
			options : { 
				handler(){
					this.get_list();
				}, deep : true
			}, // options

			search: function(val) {
				if (!val) {
					this.get_list();
				}
			}, // search
			
			// Watcher para la paginación de la tabla de entidades
			tableOptions: {
				handler() {
					if (this.selected_list) {
						this.get_entities();
					}
				},
				deep: true
			},

			// Watcher para el paso de configuración
			selected_list: {
				handler(newVal) {
					if (newVal) {
						this.setup_step = 1;
					} else {
						this.setup_step = 0;
					}
				}
			},

			motive: {
				handler(newVal) {
					if (newVal && this.selected_list) {
						this.setup_step = 2;
					} else if (!newVal && this.selected_list) {
						this.setup_step = 1;
					}
				}
			},

			selected_entities: {
				handler(newVal) {
					if (newVal.length > 0 && this.selected_list && this.motive) {
						this.setup_step = 3;
					} else if (this.selected_list && this.motive) {
						this.setup_step = 2;
					}
				},
				deep: true
			}
		
		}, // watch

		computed : {
			render_list : function(){	
				if (this.search) {
					// if (this.item_search) {}
					if(this.head?.title1=='face'){
						const tempSearch=this.search.toLowerCase();
						const temp=this.list.filter((x,idx, array)=>{
							const valid=(x?.name_entity?.toLowerCase().indexOf(tempSearch) || (x?.face_trained?.name?.toLowerCase().includes(tempSearch)) && array.findIndex(z=> z.id == x.id) == idx)
							// console.log("CHECK 00000000000 " , valid, x, x?.face_trained?.name )
							return valid
						})
					// console.log("SEARC ", this.search, this.list, this.item_search,this.$Helper.filter_search(this.search, this.list, this.item_search), temp )
						return temp
					}else{
						return this.$Helper.filter_search(this.search, this.list, this.item_search);						
					}					
				}else{					
					return this.list;
				}			
			}, // render_list

			currentUser() {		        
		        return this.$store.state.auth.user;      
		    },

		    route_type : function(){
		    	let type = this.$route.name.split("_")[1];
		    	// console.log("CHEK TYPE : ", type , ' ? ', this.head.title1 , this.$route.name)
		    	if (type != this.head.title1) {
		    		this.render_created();
		    		this.options.page = 1;	    		
		    		this.$nextTick(()=>{
		    			this.get_list();
		    		});
		    		this.head.title1 	= type;
		    	}
		    	return type;;
		    }, // route type

		    render_entity : function(){
		    	return this.list_entity;
		    },
		    renderLists(){
		    	return this.list_lists.filter((item_list) => {
					if (item_list && item_list.name && this.head && this.head.title1 == item_list.type) {																		
						return item_list
					}
				})
		    },
		    isRequiredInfo(){
		    	// console.log("-----------------------", this.btn_action, !this.required_info, )
		    	if(this.head?.title1=='face'){
		    		// Para face: requiere entity (cara entrenada) y listId
		    		const hasEntity = this.info?.entity && (
		    			(Array.isArray(this.info.entity) && this.info.entity.length > 0) ||
		    			(typeof this.info.entity === 'object' && this.info.entity.userId) ||
		    			(typeof this.info.entity === 'string' && this.info.entity.trim() !== '')
		    		);
		    		const hasListId = this.info?.listId;
		    		return !(hasEntity && hasListId);
		    	}else if(this.head?.title1=='lpr' || this.head?.title1=='parking'){
		    		// Para lpr/parking: requiere plate_char y listId
		    		const hasPlateChar = this.info?.plate_char && this.info.plate_char.trim() !== '';
		    		const hasListId = this.info?.listId;
		    		return !(hasPlateChar && hasListId);
		    	}else{
		    		// Fallback para otros tipos
		    		return !(this.info.plate_char && this.info.listId);
		    	}
		    }

		}, // computed

		methods : {
			actions(act, item, opt) {
				// console.log("Actions ", act, item, opt)
				if (act == 'show') {
					this.show.add = !this.show.add;
					if (this.btn_action == 'update' || this.btn_action == 'save') {
						this.actions('clear_info');
					}
				}
				if ( act == 'clear_info') {
					this.btn_action = 'save';
					this.info 		= {};
					this.info_item  = {};
					this.sub_title 	= this.$ml.get('register');
				}
				if (act == 'save') {
					this.save();
				}
				if (act == 'update') {
					this.save(true);
				}
				if (act == 'edit') {					

					this.info 		= {...item};
					if(item.entity){
						this.info.entity=[item.entity];
					}
					if (this.info && this.info.listId && typeof this.info.listId == "string") {
						this.info.listId=parseInt(this.info.listId); 
					}					
					// this.info_item 	= this.list.indexOf(item);
					this.show.add	= true;
					this.sub_title 	= this.$ml.get('update');
					this.btn_action = 'update';
				}
				if ( act == 'confirm_delete') {
					this.info_item = item;

					EventBus.$emit('notifications_modal',{
						type  : 'confirm_delete',
						ID 	  : this.ID_notification,
					});
				}
					// console.log("import excel : ", this.info_import)
				if (act == 'import_excel') {
					this.import_excel();
					// console.log("import excel : ", this.info_import)
				}
				if (act == 'export_excel') {
					this.export_excel();
				}
				if ( act == "search") {
					if (item) {
						this.search = item;
						this.get_list(item);
					}else{
						this.search = "";						
						this.get_list();
					}
				}
			}, // actions



			render_listeds(list){
				if (this[list]) {
					return this[list];
				}else{
					return list;
				}

			}, // render_list
			

			render_created(){
				this.info_fields[1].enable = true;
				this.info_fields[2].enable = false;
				if (this.list_entity && this.list_entity.length==0) {
		    		// this.get_traineds();
				}
				if (this.$route.name == 'list_face') {
					this.head.title1 	= 'face';
					let idx 			= this.header_table.findIndex(x => (x && x.value == "plate_char"));
					// console.log("idx field  face ", idx)
					if (idx >= 0) {
						this.header_table.splice(idx, 1, { text : this.$ml.get('entity'), value : 'name_entity' })
					}
					// let idx_face 		= this.list_fields.findIndex(x => (x && x.key == "plate_char"));
					this.info_fields[1].enable = false;
					this.info_fields[2].enable = true;

				}else if (this.$route.name == "list_parking") {
					this.head.title1 = 'parking';
					// profile					

				}else if (this.$route.name == "list_lpr") {
					this.head.title1 = "lpr";
				}
				if (this.head && this.head.title1 == 'lpr' || this.head.title1 == 'parking') {

					this.item_search.key_search   = 'plate_char';
					let idx 			= this.header_table.findIndex(x => (x && x.value == "name_entity"));					
					if (idx >= 0) {
						this.header_table.splice(idx, 1, { text : this.$ml.get('plate_char'), value : 'plate_char' })

					}
					// this.item_search.key_search_1 = '';
				}else if (this.head.title1 == "face"){
					this.item_search.key_search   = 'name_entity';

				}
				
				let modul = this.$store.getters["auth/permission"](this.$route.name || this.head.title1, "", this.head.title1);
				if (modul) {					
					if (modul.can_edit) { //
						this.show.edit_detail = true;						
					}else{
						this.show.edit_detail = false;						
					}
					if (modul.can_delete) {
						this.show.delete_detail = true;						
					}else{
						this.show.delete_detail = false;
					}
					// console.log( "add action ", modul.can_edit || modul.can_delete)
					if (!modul.can_edit && !modul.can_delete) {
						let idx_actions = this.header_table.findIndex(x => (x.value == 'actions'));
						if (idx_actions >= 0) {
							this.header_table.splice(idx_actions, 1);
						}
					}
					if (!modul.can_add) {
						this.show.add_detail = false;
					}
				}

			}, // render created

			get_list(search){
				const { itemsPerPage, page } = this.options;
				let option 	= 'get';
				let api 	= this.$URL + '/api/v1/listing_details_type/' + this.head.title1 + '/?page=' + page;
				let info_up = {};
				if (search) {
					api 	= this.$URL + '/api/v1/listing_details/find/';
					option  = 'post';
					info_up.type=this.head.title1;
					if (this.head && this.head.title1 == 'lpr' || this.head.title1 == 'parking') {
						info_up.where = {plate_char : search};
					}else{
						info_up.where = {
							name: search,
							motive:search

						}; // entity


					}
				}
				this.list 	 = [];
				this.loading = true;
				
				this.$axios[option](api, info_up).then( res => {
					// console.log(res, 'res get_list');
					let items = res.data.rows;
					if (items && items.length > 0) {
						const listTemp=[]
						items.forEach((list_item) =>{
							if (list_item) {
								listTemp.push(this.format_info(list_item));								
							}
						})
						listTemp.sort(function(a,b){
						  // Turn your strings into dates, and then subtract them
						  // to get a value that is either negative, positive, or zero.
						  return    new Date(b.createdAt) - new Date(a.createdAt);
						});
					}
					this.total 	 = res.data.count;
					this.list 	 = [ ...items ];
					// this.listed  = [ ...items ];
					this.loading = false;

				}).catch( er => {
					this.loading = false;					
					console.log(er, this.$ml.get('error_get_list'));
					let  err = er && er.message ? er.message : er;
						

					this.$EventBus.$emit('notifications_modal',{
							type  	: 'error',
							message :  err
						});
				})

			}, // get list
			
			get_listing(pg = 1){
				
				// const { itemsPerPage, page } = this.options;
				
				let vm 		= this;
				const api 	= this.$URL + '/api/v1/list/?page=' + pg;
				// this.loading = true;
				
				this.$axios.get(api).then( res => {
					// console.log(res, 'res get_list');
					if (res && res.data && res.data.rows && res.data.rows.length > 0) {

						let items = res.data.rows;
						// this.total = res.data.count;
						let temp_list = [];

						if (items && items.length > 0) {
							temp_list=items
						}
						// console.log(" LISTS : ", temp_list, items)
						if (temp_list && temp_list.length > 0) {

							this.list_lists = this.list_lists.concat(temp_list);
							// this.required_info = true;
							if (parseInt(res.data.pages) > pg ) {
								this.get_listing(pg++);
							}
						}else{
													if (this.list_lists && this.list_lists.length == 0) {							
							this.$EventBus.$emit('notifications_modal', {
								type 	: 'warning',
								message : this.$ml.get('required_have_list_created')
							})
						}
						}
					}else{
						if (this.list_lists && this.list_lists.length == 0) {							
							this.$EventBus.$emit('notifications_modal', {
								type 	: 'warning',
								message : this.$ml.get('required_have_list_created')
							})
						}
					}
					// this.loading = false;

				}).catch( er => {
					// this.loading = false;					
					console.log(er, this.$ml.get('error_get_list'));
					let err = er && er.message ? er.message : er;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('failed_get_lists') + ' : ' + err
					})
				})
			}, // get listing

			

			async get_traineds(){
				let page  = 1,
		          	pages = 2,
		          	list  = []; 

		        while (page <= pages){

					const api = this.$URL + "/api/v1/face/trained/?page=" + page;
					// '/api/face/list?page='
					
					const listed =  await  
					this.$axios.get(api).then( res => {
						if (res && res.data && res.data.rows && res.data.rows.length > 0) {

							let items 	=  res.data.rows;
			            	// if (res.data.pages > page){ // next
			                // }
							
							if (page == 1) {			                
				                list  = items;
			                  	pages = parseInt(res.data.pages);      
				            }else{
				                list = list.concat(items);
				            }
						}

			            return list;
						
					}).catch( er =>{
						console.log(er, this.$ml.get('error_get_list_trained'))
					})
					page++;		        
		    	}
		       	// console.log("list trained ", list)
		       	if (list && list.length > 0) {     
		       		// list.unshift({faceUUID : "all", userName : this.$ml.get("all"), name : "All"})
		       		this.list_entity 		= list;
					this.update_list();

		       		
		       	}
			}, // get traineds 


			save(up){
				if (up) {
					if (!this.$store.getters["auth/permission"]( this.$route.name || "lists", "can_edit", this.head.title1)) {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get(this.head.title1),
						})
						this.action_to_field.action = '1';
						return false;
					}
				}else{
					if (!this.$store.getters["auth/permission"]( this.$route.name || "lists", "can_add", this.head.title1)) {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get(this.head.title1),
						})
						this.action_to_field.action = '1';
						return false;
					}
				}
				let opt 	= 'post';
				let info_up = { ...this.info };
				let api 	= this.$URL + '/api/v1/listing_details';
				let check  	= false;
				let msg 	= ''; 

				this.loading = true;
				
				// Procesar datos según el tipo de registro
				if (this.head.title1 == "face") {
					// Para face: procesar entity (cara entrenada)
					if (info_up && info_up.entity) {
						if (Array.isArray(info_up.entity)) {
							// Si es array, tomar el primer elemento o convertir a array de IDs
							info_up.entity = info_up.entity.map(entity => 
								typeof entity === 'object' ? entity.userId : entity
							);
						} else if (typeof info_up.entity === 'object' && info_up.entity.userId) {
							// Si es objeto con userId, extraer el userId
						info_up.entity = info_up.entity.userId;
					}
						// Si ya es string, mantenerlo como está
				}
				} else if (this.head.title1 == "lpr" || this.head.title1 == "parking") {
					// Para lpr/parking: procesar plate_char
				if (info_up && info_up.plate_char) {
						// Limpiar espacios y convertir a mayúsculas para consistencia
						info_up.plate_char = info_up.plate_char.replace(/\s+/g, '').toUpperCase();
					}
				}
				if (up) {
					opt = 'put';					
					msg = 'Not found id'
					if (info_up && info_up.id ) {
						api   += '/' + info_up.id;
						check = true;
						msg   = '';
					}
				}else{
					check = true;
				}

				// Validaciones específicas según el tipo
				if (!info_up.listId) {
					check = false;
					msg   = this.$ml.get('require_sel_list');
				} else if (this.head.title1 == "face") {
					// Validación específica para face
					if (!info_up.entity || (Array.isArray(info_up.entity) && info_up.entity.length === 0)) {
						check = false;
						msg   = this.$ml.get('require_select_face_entity') || 'Se requiere seleccionar una cara entrenada';
					}
				} else if (this.head.title1 == "lpr" || this.head.title1 == "parking") {
					// Validación específica para lpr/parking
					if (!info_up.plate_char || info_up.plate_char.trim() === '') {
						check = false;
						msg   = this.$ml.get('require_plate_char') || 'Se requiere ingresar la placa del vehículo';
					}
				}
				
				info_up.type = this.head.title1;

				if (check) {
					this.$axios[opt](api, info_up).then( res => {
						// console.log('res ', opt, 'list setting', res );
						this.$EventBus.$emit('notifications_modal',{
							type : up ? 'updated' : 'saved', 
						});
						this.loading = false;
						// this.$router.back();
						if (!up) { // save

							this.total ++;							 
							if (opt=='post') {
								if(info_up.type=='face'){
									if(res?.data){
										if(res?.data?.length){
											const listErrors=[];
											const listTemp=[];
											let msgTemp=""
											res?.data.forEach((it)=>{
												if(it.msg){
													msgTemp=it.msg;
													listErrors.push(it)
												}else{
													listTemp.push(it)
												}
											})
											if(listErrors.length){
												const temp = (msgTemp=="The face is already registered in the list.")? this.$ml.get("face_already_registered_in_list") : msgTemp
												this.$EventBus.$emit("notifications_modal",{ type: "warning", message: `${this.$ml.get('have_been_registered')} ${listTemp.length}, ${this.$ml.get('have_not_been_registered')} ${listErrors.length}, ${temp} `})
											}else if(listTemp.length){
												this.$EventBus.$emit("notifications_modal",{ type: "success", message: `${this.$ml.get('have_been_registered')} ${listTemp.length}`})
											}
										}
									}

									this.get_list();

								}else{									
									// Handle single item response (array with one item)
									let responseData = res.data;
									if (Array.isArray(responseData) && responseData.length === 1) {
										responseData = responseData[0];
									}
									
									let info_res = this.format_info(responseData);
									if (info_res) {
										// Add to the beginning of the list to show the newest item first
										this.list.unshift(info_res);
									}
								}
							}
						}else{
							let info_res=this.format_info(info_up);
							const idx = this.list.findIndex(x=> x.id == info_up.id)							
							if (idx >= 0) {
								this.list.splice(idx,1,{...info_res});
							}
						}
						if (this.show.add) {
							this.actions('show');
						}
						this.isErrors.plate_char=false;
						this.messages.plate_char=[""]	
					}).catch(er => {
						this.loading = false;						
						console.log(this.$ml.get('error_list_setting'), opt, er);
						let  err = "";//up ? this.$ml.get('update')+' ' : this.$ml.get('save')+' ';
						if (er && er.response && er.response.data && er.response.data.msg && er.response.data.msg == "The vehicle license plate is registered") {					
							// The vehicle license plate is registered
							err += this.$ml.get("already_exist_plate")
							this.isErrors.plate_char=true;
							this.messages.plate_char=[this.$ml.get("already_exist_plate")];
							// 
						}else{
							this.isErrors.plate_char=false;
							this.messages.plate_char=[""]						
							err += er && er.response && er.response.data && er.response.data.message ? er.response.data.message : er;
						}					

						this.$EventBus.$emit('notifications_modal',{
							type  	: 'error',
							message :  err
						});

					})

				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  msg
					});
					this.loading = false;

				}
			}, // save

			import_excel(){
				if (this.info_import) {
					
					const api 	 = this.$URL + "/api/v1/listing_details/import";				
					let formData = new FormData();
					let info_up  = this.info_import;
					let type 	 = this.head.title1;
			        // set form data of file
			        formData.append("file", info_up);
			        formData.append("type", type);

			       			       	
			       	this.$axios.post(api, formData).then(res => {
						console.log(this.$ml.get('res_logos'), res )
						if (res && res.data) {
							this.$EventBus.$emit('notifications_modal',{
								type : 'updated',
							})
							this.info_import = null;
							this.get_list();
						
							// this.info_images[file] = this.$URL + res.data.url_path;
						}
						/**/
					}).catch( er => {
						
						// this.loading = false;
						/*
							er && er.message ? er.message : er
						*/
						this.info_import = null;

						console.log(this.$ml.get('error_logos'), er);
						this.$EventBus.$emit('notifications_modal',{
							type 	: 'error',
							message : er
						})
					})
				    // } // for
				}
			}, // import excel
			async importZip(){
				try{
					this.loading=true;
					if(this.infoZip){
						const api 	 = this.$URL + "/api/v1/preloadzip";				
						let formData = new FormData();
						formData.append("files", this.infoZip);
						const res= await this.$axios.post(api, formData)
						if(res?.error){

						}else if(res?.data){

						}
					}
				}catch(error){
					console.warn("error import zip ", error)
				}finally{
					this.loading=false;
				}
			},
			del(item){
				if (item) {
					let idx = this.list.indexOf(item);
					if (item.id) {
						this.loading = true;

						const api = this.$URL + '/api/v1/listing_details/' + item.id;
						this.$axios.delete(api).then(res =>{
							this.$EventBus.$emit('notifications_modal',{
							type : 'deleted', 							
						});
						this.list.splice(idx, 1);
						// this.listed = this.list;
						if (this.list && this.list.length === 0) {
							this.total = 0;
						}else{
							this.total--;
						}

						this.loading = false;
						if (this.show.add) {
							this.actions('show');
						}
						}).catch( er => {
							console.log(this.$ml.get('error_deleting'), er);
							this.loading = false;
							let  err = up ? this.$ml.get('update') + ' ' : this.$ml.get('save') + ' ';
							err += er && er.message ? er.message : er;
							this.$EventBus.$emit('notifications_modal',{
								type  	: 'error',
								message :  this.$ml.get('deleting_item') + ' ' + err
							});
						})
					}else{
						this.$EventBus.$emit('notifications_modal',{
							type  	: 'warning',
							message :  this.$ml.get('item_to_delete_have_id')
						});	
					}
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'warning',
						message :  this.$ml.get('item_to_delete_null')
					});
				}
			}, // item

			format_info(item){
				if (item){				
					// Debug: mostrar la estructura del item
					console.log('format_info - item original:', item);
					console.log('format_info - listId:', item.listId);
					console.log('format_info - list_lists disponibles:', this.list_lists);
					
					// Procesar información de lista según el tipo
					if (item.listId) {						
						let listIndex = this.list_lists.findIndex( x => x.id == item.listId);
						console.log('format_info - listIndex encontrado:', listIndex);
						if (listIndex >= 0) {
							let temp_lists = this.list_lists[listIndex];		
							item.list = temp_lists ? temp_lists.name : item.listId;
							console.log('format_info - nombre de lista asignado:', item.list);
						} else {
							item.list = item.listId; // Fallback to listId if list not found
							console.log('format_info - usando listId como fallback:', item.list);
						}
					}
					
					// Procesar detail_lists si existe
					if (item.detail_lists && Array.isArray(item.detail_lists)) {
						console.log('format_info - procesando detail_lists:', item.detail_lists);
						// Asegurar que cada elemento tenga la información necesaria
						item.detail_lists = item.detail_lists.map(list => {
							if (list.listId) {
								let listIndex = this.list_lists.findIndex(x => x.id == list.listId);
								if (listIndex >= 0) {
									list.listName = this.list_lists[listIndex].name;
								} else {
									list.listName = `List ${list.listId}`;
								}
							}
							return list;
						});
						console.log('format_info - detail_lists procesado:', item.detail_lists);
					}
					
					// Procesar información específica según el tipo de registro
					if (this.head.title1 === 'face') {
						// Para face: procesar información de cara entrenada
					if (item.entity) {					
						if(item?.face_trained && (item?.face_trained?.length ?? 0) > 0){
								item.name_entity = item.face_trained[0].name;
								// Agregar información adicional de la cara entrenada
								if (item.face_trained[0].face_cropping && item.face_trained[0].face_cropping.url) {
									item.urlImg = this.$URL + item.face_trained[0].face_cropping.url;
								}
						}else if(item?.face_trained && item?.face_trained?.name){
								item.name_entity = item.face_trained.name;
								if (item.face_trained.face_cropping && item.face_trained.face_cropping.url) {
									item.urlImg = this.$URL + item.face_trained.face_cropping.url;
								}
						}else{
							let temp = this.render_entity.findIndex( x => x.userId == item.entity) ;
							if (temp >= 0) {
								item.name_entity = this.render_entity[temp].userName;
									// Agregar imagen si está disponible
									if (this.render_entity[temp].face_cropping && this.render_entity[temp].face_cropping.url) {
										item.urlImg = this.$URL + this.render_entity[temp].face_cropping.url;
									}
								}											
							}
						}
					} else if (this.head.title1 === 'lpr' || this.head.title1 === 'parking') {
						// Para lpr/parking: procesar información de placa
						if (item.plate_char) {
							// Normalizar formato de placa
							item.plate_char_formatted = item.plate_char.toUpperCase().replace(/\s+/g, '');
							// Agregar información adicional si está disponible
							if (item.vehicle_info) {
								item.vehicle_details = item.vehicle_info;
							}
						}
					}
					
					console.log('format_info - item final:', item);
					return item;			
				}
				return null
			}, // format info
			
			update_list(){
				if (this.list && this.list.length > 0) {				
					this.list.map((it)=>{
						it=this.format_info(it);						
						return it
					})		
				}	
			}, // update list 

			// Modal de Entidades
			openAddModal() {
				// Para LPR/Parking: mostrar formulario inline
				if (this.head.title1 === 'lpr' || this.head.title1 === 'parking') {
					this.actions('show'); // Mostrar formulario inline
					return;
				}
				
				// Para Face: mostrar modal de entidades
				console.log(this.$ml.get('opening_modal')); // Debug
				this.show.add_modal = true;
				this.selected_list = null;
				this.selected_entities = [];
				this.motive = ''; // Limpiar el campo motivo
				this.filter_name = '';
				this.filter_date = null;
				this.date_menu = false;
				this.setup_step = 0; // Resetear el paso de configuración
				console.log(this.$ml.get('modal_state'), this.show.add_modal); // Debug
			},
			closeAddModal() {
				this.show.add_modal = false;
				this.selected_list = null;
				this.selected_entities = [];
				this.motive = ''; // Limpiar el campo motivo
				this.filter_name = '';
				this.filter_date = null;
				this.filter_list_status = 'all'; // Resetear el filtro de estado de la lista
				this.date_menu = false;
				this.select_all_mode = false;
				this.all_entities = [];
				this.setup_step = 0; // Resetear el paso de configuración
			},
			onListChange() {
				console.log(this.$ml.get('list_changed_to'), this.selected_list); // Debug
				this.selected_entities = [];
				this.select_all_mode = false;
				this.all_entities = [];
				this.setup_step = 1; // Pasar al siguiente paso
				if (this.selected_list) {
					this.get_entities(); // Cargar entidades cuando cambie la lista
				}
			},
			applyFilters() {
				// Si hay filtros activos y estamos en modo global, resetear
				if (this.select_all_mode) {
					this.select_all_mode = false;
					this.selected_entities = [];
					this.all_entities = [];
					
					EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: this.$ml.get('filters_changed_global_mode_deactivated')
					});
				}
				
				this.get_entities();
			},
			onDateChange(date) {
				this.filter_date = date;
				
				// Si hay filtros activos y estamos en modo global, resetear
				if (this.select_all_mode) {
					this.select_all_mode = false;
					this.selected_entities = [];
					this.all_entities = [];
					
					EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: this.$ml.get('date_changed_global_mode_deactivated')
					});
				}
				
				this.get_entities();
			},
			clearFilters() {
				this.filter_name = '';
				this.filter_date = null;
				this.filter_list_status = 'all'; // Resetear el filtro de estado de la lista
				this.select_all_mode = false;
				this.selected_entities = [];
				this.all_entities = [];
				this.get_entities();
			},
			async get_entities() {
				if (!this.selected_list) {
					EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: this.$ml.get('please_select_list_first')
					});
					return;
				}
				this.loading_entities = true;
				try {
					// Usamos la API correcta para entidades entrenadas
					const api = this.$URL + '/api/v1/face/trained/';
					const params = {
						page: this.tableOptions.page,
						limit: 100 // Usar un límite alto para reducir el número de páginas
					};
					
					// Agregar filtros si están definidos
					if (this.filter_name) {
						params.search = this.filter_name;
					}
					if (this.filter_date) {
						params.date = this.filter_date;
					}
					
					const res = await axios.get(api, { params });
					console.log(this.$ml.get('api_response'), res.data); // Debug
					console.log(this.$ml.get('api_url'), api); // Debug
					console.log(this.$ml.get('api_params'), params); // Debug
					this.filtered_entities = res.data.rows || [];
					this.total = res.data.count || 0;
					console.log(this.$ml.get('filtered_entities'), this.filtered_entities.length); // Debug
					console.log(this.$ml.get('total'), this.total); // Debug
					
					// Debug: Ver la estructura de la primera entidad para identificar el campo UUID
					if (this.filtered_entities.length > 0) {
						console.log('Primera entidad:', this.filtered_entities[0]);
						console.log('Campos disponibles:', Object.keys(this.filtered_entities[0]));
					}
					
					// Actualizar las opciones de la tabla con la información real del backend
					if (res.data.pages && res.data.limit) {
						this.tableOptions.itemsPerPage = res.data.limit;
					}
				} catch (error) {
					console.error('Error fetching entities:', error);
					EventBus.$emit('notifications_entities', {
						type: 'error',
						message: error.message || this.$ml.get('failed_to_fetch_entities')
					});
				} finally {
					this.loading_entities = false;
				}
			},
			
			// Método para obtener TODAS las entidades de todas las páginas
			async getAllEntities() {
				if (!this.selected_list) {
					EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: this.$ml.get('please_select_list_first')
					});
					return;
				}
				
				this.loading_all_entities = true;
				try {
					const api = this.$URL + '/api/v1/face/trained/';
					
					// Construir parámetros de filtros para logging
					const filterInfo = [];
					if (this.filter_name) filterInfo.push(`nombre: "${this.filter_name}"`);
					if (this.filter_date) filterInfo.push(`fecha: "${this.filter_date}"`);
					
					console.log(`${this.$ml.get('applying_filters')}: ${filterInfo.length > 0 ? filterInfo.join(', ') : this.$ml.get('none')}`);
					
					// Primero obtenemos el total de entidades para calcular cuántas páginas hay
					// Usamos un límite más alto para obtener el count y reducir el número de páginas
					const totalParams = {
						page: 1,
						limit: 100 // Usar un límite más alto para obtener el count
					};
					
					// Agregar filtros si están definidos
					if (this.filter_name) {
						totalParams.search = this.filter_name;
					}
					if (this.filter_date) {
						totalParams.date = this.filter_date;
					}
					
					const totalRes = await axios.get(api, { params: totalParams });
					const totalEntities = totalRes.data.count || 0;
					const itemsPerPage = 100; // Usar un límite fijo y alto para reducir el número de páginas
					const totalPages = Math.ceil(totalEntities / itemsPerPage);
					
					console.log(`${this.$ml.get('total_entities')}: ${totalEntities}, ${this.$ml.get('total_pages')}: ${totalPages}, ${this.$ml.get('items_per_page')}: ${itemsPerPage}`);
					
					// Ahora obtenemos todas las entidades página por página
					this.all_entities = [];
					
					for (let page = 1; page <= totalPages; page++) {
						const params = {
							page: page,
							limit: itemsPerPage
						};
						
						// Agregar filtros si están definidos
						if (this.filter_name) {
							params.search = this.filter_name;
						}
						if (this.filter_date) {
							params.date = this.filter_date;
						}
						
						const res = await axios.get(api, { params });
						const pageEntities = res.data.rows || [];
						
						// Agregar las entidades de esta página al array total
						this.all_entities = [...this.all_entities, ...pageEntities];
						
						console.log(`📄 ${this.$ml.get('page')} ${page}: ${pageEntities.length} ${this.$ml.get('entities_loaded')}. ${this.$ml.get('total_so_far')}: ${this.all_entities.length}`);
					}
					
					console.log(`✅ ${this.$ml.get('all_entities_loaded')}: ${this.all_entities.length} ${this.$ml.get('out_of')} ${totalEntities}`);
					
					// Verificar que obtuvimos todas las entidades
					if (this.all_entities.length !== totalEntities) {
						console.warn(`⚠️ ${this.$ml.get('warning')}: ${this.$ml.get('expected')} ${totalEntities} ${this.$ml.get('entities_but_got')} ${this.all_entities.length}`);
					}
					
				} catch (error) {
					console.error(this.$ml.get('error_fetching_all_entities'), error);
					EventBus.$emit('notifications_modal', {
						type: 'error',
						message: this.$ml.get('error_loading_all_entities')
					});
				} finally {
					this.loading_all_entities = false;
				}
			},
			
			// Método para seleccionar todas las entidades
			async selectAllEntities() {
				if (this.select_all_mode) {
					// Si ya está en modo "seleccionar todos", desactivar
					this.select_all_mode = false;
					this.selected_entities = [];
					this.all_entities = [];
					
									EventBus.$emit('notifications_modal', {
					type: 'info',
					message: this.$ml.get('global_selection_mode_deactivated')
				});
					return;
				}
				
				// Verificar si hay filtros activos
				const hasFilters = this.filter_name || this.filter_date;
				let filterMessage = '';
				
				if (hasFilters) {
					filterMessage = ' ' + this.$ml.get('with_filters_applied') + ':';
					if (this.filter_name) filterMessage += ` ${this.$ml.get('name')}="${this.filter_name}"`;
					if (this.filter_date) filterMessage += ` ${this.$ml.get('date')}="${this.filter_date}"`;
				}
				
				// Activar modo "seleccionar todos"
				this.select_all_mode = true;
				
				// Mostrar mensaje de carga con información de filtros
				EventBus.$emit('notifications_modal', {
					type: 'info',
					message: this.$ml.get('loading_all_entities_from_all_pages') + filterMessage
				});
				
				// Cargar todas las entidades (con filtros aplicados)
				await this.getAllEntities();
				
				// Seleccionar todas las entidades filtradas
				this.selected_entities = [...this.all_entities];
				
				// Calcular información de paginación usando datos reales del backend
				const itemsPerPage = 100; // Usar el mismo límite alto que getAllEntities
				const totalPages = Math.ceil(this.all_entities.length / itemsPerPage);
				
				// Mensaje final con información de filtros
				let finalMessage = this.$ml.get('entities_selected_from_pages', { 
					count: this.selected_entities.length, 
					pages: totalPages, 
					perPage: itemsPerPage 
				});
				if (hasFilters) {
					finalMessage += `\n🔍 ${this.$ml.get('filters_applied')}:`;
					if (this.filter_name) finalMessage += ` ${this.$ml.get('name')}: "${this.filter_name}"`;
					if (this.filter_date) finalMessage += ` ${this.$ml.get('date')}: "${this.filter_date}"`;
				}
				
				EventBus.$emit('notifications_modal', {
					type: 'success',
					message: finalMessage
				});
			},
			
			// Método para deseleccionar todas las entidades
			deselectAllEntities() {
				this.selected_entities = [];
				this.select_all_mode = false;
				this.all_entities = [];
			},
			
			async addEntitiesToList() {
				if (!this.selected_list) {
					EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: this.$ml.get('please_select_list_first')
					});
					return;
				}
				if (this.selected_entities.length === 0) {
					EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: this.$ml.get('no_entities_selected')
					});
					return;
				}
				
				// Validaciones específicas según el tipo de lista
				if (this.head.title1 === 'face') {
					// Para listas de face: validar que las entidades sean caras entrenadas
					const invalidEntities = this.selected_entities.filter(entity => 
						!entity.userId && !entity.id && !entity.faceUUID && !entity.uuid
					);
					
					if (invalidEntities.length > 0) {
						EventBus.$emit('notifications_modal', {
							type: 'error',
							message: `${this.$ml.get('invalid_entities_for_face_list')}: ${invalidEntities.length} ${this.$ml.get('entities_without_valid_face_id')}`
						});
						return;
					}
					
					// Verificar que las entidades tengan información de cara entrenada
					const entitiesWithoutFaceData = this.selected_entities.filter(entity => 
						!entity.face_trained || (!entity.face_trained.name && !entity.userName)
					);
					
					if (entitiesWithoutFaceData.length > 0) {
						EventBus.$emit('notifications_modal', {
							type: 'warning',
							message: `${this.$ml.get('warning')}: ${entitiesWithoutFaceData.length} ${this.$ml.get('entities_without_face_data')}`
						});
					}
					
				} else if (this.head.title1 === 'lpr' || this.head.title1 === 'parking') {
					// Para listas de lpr/parking: validar que las entidades tengan información de placa
					const entitiesWithoutPlate = this.selected_entities.filter(entity => 
						!entity.plate_char || entity.plate_char.trim() === ''
					);
					
					if (entitiesWithoutPlate.length > 0) {
						EventBus.$emit('notifications_modal', {
							type: 'error',
							message: `${this.$ml.get('invalid_entities_for_plate_list')}: ${entitiesWithoutPlate.length} ${this.$ml.get('entities_without_plate_data')}`
						});
						return;
					}
				}
				
				// Verificar si hay entidades que ya están en la lista seleccionada
				const entitiesAlreadyInList = this.selected_entities.filter(entity => 
					this.isEntityInSelectedList(entity)
				);
				
				if (entitiesAlreadyInList.length > 0) {
					const warningMessage = `${this.$ml.get('warning')}: ${entitiesAlreadyInList.length} ${this.$ml.get('entities_already_in_selected_list')}`;
					
					EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: warningMessage
					});
					
					// Filtrar solo las entidades que NO están en la lista seleccionada
					this.selected_entities = this.selected_entities.filter(entity => 
						!this.isEntityInSelectedList(entity)
					);
					
					if (this.selected_entities.length === 0) {
						EventBus.$emit('notifications_modal', {
							type: 'info',
							message: this.$ml.get('all_entities_already_in_list')
						});
						return;
					}
				}
				this.adding_entities = true;
				try {
									// Debug: Ver la estructura de las entidades seleccionadas
				console.log('Entidades seleccionadas:', this.selected_entities);
				
				// Identificar los UUIDs de todas las entidades
				const entityIds = [];
				const invalidEntities = [];
				
				this.selected_entities.forEach(entity => {
					console.log('Entidad a agregar:', entity);
					console.log('Campos disponibles:', Object.keys(entity));
					
					// Identificar el campo UUID correcto
					const entityId = entity.userId || entity.id || entity.faceUUID || entity.uuid;
					
					if (entityId) {
						entityIds.push(entityId);
					} else {
						invalidEntities.push(entity);
						console.error('No se pudo encontrar el ID de la entidad:', entity);
					}
				});
				
				// Verificar que todas las entidades tengan UUID válido
				if (invalidEntities.length > 0) {
					throw new Error(`${this.$ml.get('invalid_entities_for_face_list')}: ${invalidEntities.length}`);
				}
				
				// Crear un solo request con todas las entidades
				const data = {
					listId: this.selected_list,
					entity: entityIds, // Array de UUIDs de todas las entidades
					motive: this.motive || this.$ml.get('added_via_modal'), // Usar el motivo ingresado o el predeterminado
					type: this.head.title1 // Agregar el tipo de lista (face, lpr, parking)
				};
				
				console.log('Datos a enviar a la API (un solo request):', data);
				
				// Enviar un solo request con todas las entidades
				const response = await axios.post(this.$URL + '/api/v1/listing_details/', data);
					
					// Verificar la respuesta de la API
					if (response.status === 200 || response.status === 201) {
						console.log('Respuesta exitosa de la API:', response.data);
						
						// Mostrar mensaje de éxito
						EventBus.$emit('notifications_modal', {
							type: 'saved',
							message: this.$ml.get('entities_added_to_list') + ' ' + entityIds.length
						});
					} else {
						console.warn('Respuesta inesperada de la API:', response);
						
						EventBus.$emit('notifications_modal', {
							type: 'warning',
							message: this.$ml.get('entities_added_to_list') + ' ' + entityIds.length + ' - ' + this.$ml.get('unexpected_response')
						});
					}
					
					this.closeAddModal();
					this.get_list(); // Refresh the main list
				} catch (error) {
					console.error('Error adding entities to list:', error);
					
					// Mostrar información detallada del error
					let errorMessage = this.$ml.get('failed_to_add_entities');
					if (error.response && error.response.data) {
						if (error.response.data.message) {
							errorMessage += ': ' + error.response.data.message;
						} else if (error.response.data.msg) {
							errorMessage += ': ' + error.response.data.msg;
						}
					} else if (error.message) {
						errorMessage += ': ' + error.message;
					}
					
					EventBus.$emit('notifications_modal', {
						type: 'error',
						message: errorMessage
					});
				} finally {
					this.adding_entities = false;
				}
			},
			viewEntityDetails(item) {
				// Implement navigation or modal for entity details
				console.log(this.$ml.get('viewing_details_for_entity'), item);
				// Example: Navigate to a new page or show a modal
				// this.$router.push({ name: 'entity_details', params: { id: item.userId } });
			},
			

			formatDate(timestamp) {
				if (!timestamp) return '';
				const date = new Date(timestamp);
				return date.toLocaleDateString();
			},
			
			getEntityImage(item) {
				// Obtener la imagen de la entidad entrenada
				if (item && item.face_trained && item.face_trained.length > 0 && 
					item.face_trained[0].face_cropping && item.face_trained[0].face_cropping.url) {
					return this.$URL + item.face_trained[0].face_cropping.url;
				}
				return '/img/no_img_found.png';
			},

			getListName(listId) {
				// Buscar el nombre de la lista basado en el listId
				const list = this.list_lists.find(l => l.id == listId);
				return list ? list.name : `List ${listId}`;
			},

			isEntityInSelectedList(entity) {
				// Verificar si la entidad ya está en la lista seleccionada
				if (!this.selected_list || !entity.detail_lists) {
					return false;
				}
				return entity.detail_lists.some(list => list.listId == this.selected_list);
			},



			getEffectiveEntitiesCount() {
				const entitiesAlreadyInList = this.selected_entities.filter(entity => 
					this.isEntityInSelectedList(entity)
				);
				return this.selected_entities.length - entitiesAlreadyInList.length;
			},

			clearError(fieldKey) {
				// Limpiar errores cuando el usuario empiece a escribir
				if (this.isErrors[fieldKey]) {
					this.isErrors[fieldKey] = false;
					this.messages[fieldKey] = [];
				}
			},

			async export_excel() {
				
				this.exporting = true;
				try {
					// Crear workbook con 3 hojas
					const workbook = await this.$Format.create_workbook_excel_async();
					
					// Hoja 1: Placas registradas (o formato base si no hay placas)
					const platesData = this.preparePlatesData();
					console.log(platesData,"platesData")
					await this.$Format.add_sheet_for_excel_async(workbook, 'Placas_Registradas', platesData);
					
					// Hoja 2: ID y nombre de listas tipo parking
					const listsData = this.prepareListsData(this.head.title1);
					console.log(listsData,"listsData")
					await this.$Format.add_sheet_for_excel_async(workbook, 'Listas', listsData);
					
					// Hoja 3: Formato con ejemplos
					const examplesData = this.prepareExamplesData();
					await this.$Format.add_sheet_for_excel_async(workbook, 'Formato_Ejemplos', examplesData);
					
					// Descargar el archivo
					await this.$Format.download_excel_async(workbook, 'export');
					
					this.$EventBus.$emit('notifications_modal', {
						type: 'success',
						message: this.$ml.get('export_completed_successfully') || 'Exportación completada exitosamente'
					});
					
				} catch (error) {
					console.error('Error exporting Excel:', error);
					this.$EventBus.$emit('notifications_modal', {
						type: 'error',
						message: this.$ml.get('error_exporting_excel') || 'Error al exportar el archivo Excel: ' + error.message
					});
				} finally {
					this.exporting = false;
				}
			},

			preparePlatesData() {
					// Definir los nombres de las columnas según el idioma
					const columns = {
						'ID': this.$ml.get('id'),
						'Placa': this.$ml.get('plate'),
						'Lista_ID': this.$ml.get('list_id'),
						'Lista_Nombre': this.$ml.get('list_name'),
						'Motivo': this.$ml.get('motive'),
						'Fecha_Creacion': this.$ml.get('creation_date'),
						'Fecha_Actualizacion': this.$ml.get('update_date')
					};
					if (this.list && this.list.length > 0) {
						return this.list.map(item => ({
							[columns['ID']]: '',
							[columns['Placa']]: item.plate_char || '',
							[columns['Lista_ID']]: item.listId || '',
							[columns['Lista_Nombre']]: item.list || this.getListName(item.listId) || '',
							[columns['Motivo']]: item.motive || '',
							[columns['Fecha_Creacion']]: '',
							[columns['Fecha_Actualizacion']]: ''
						}));
					}
					// Si no hay placas, crear formato base
					return [
						{
							[columns['ID']]: '',
							[columns['Placa']]: '',
							[columns['Lista_ID']]: '',
							[columns['Lista_Nombre']]: '',
							[columns['Motivo']]: '',
							[columns['Fecha_Creacion']]: '',
							[columns['Fecha_Actualizacion']]: ''
						}
					];
				},

			prepareListsData(type_list) {
					// Definir los nombres de las columnas según el idioma
					const columns = {
						'ID': this.$ml.get('id'),
						'Nombre': this.$ml.get('list_name'),
						'Tipo': this.$ml.get('type'),
						'Descripcion': this.$ml.get('description'),
						'Fecha_Creacion': this.$ml.get('creation_date'),
						'Fecha_Actualizacion': this.$ml.get('update_date')
					};
					const parkingLists = this.list_lists.filter(list => list.type === type_list);
					if (parkingLists.length === 0) {
						return [
							{
								[columns['ID']]: '',
								[columns['Nombre']]: '',
								[columns['Tipo']]: type_list,
								[columns['Descripcion']]: '',
								[columns['Fecha_Creacion']]: ''
							}
						];
					}
					return parkingLists.map(list => ({
						[columns['ID']]: list.id || '',
						[columns['Nombre']]: list.name || '',
						[columns['Tipo']]: list.type || type_list,
						[columns['Descripcion']]: list.description || '',
						[columns['Fecha_Creacion']]: list.createdAt || '',
						[columns['Fecha_Actualizacion']]: list.updatedAt || ''

					}));
				},

			prepareExamplesData() {

				const columns = {
						'ID': this.$ml.get('id'),
						'Placa': this.$ml.get('plate'),
						'Lista_ID': this.$ml.get('list_id'),
						'Nombre': this.$ml.get('list_name'),
						'Moive': this.$ml.get('motive'),
						'Tipo': this.$ml.get('type'),
						'Descripcion': this.$ml.get('description'),
						'Fecha_Creacion': this.$ml.get('creation_date'),
						'Fecha_Actualizacion': this.$ml.get('update_date')
					};
					


				return [
					{
						'Campo': columns['ID'],
						'Descripcion': this.$ml.get('description_id_field'),
						'Ejemplo': '',
						'Obligatorio': this.$ml.get('no'),
						'Notas': this.$ml.get('do_not_fill_this_field')
					},
					{
						'Campo': columns['Placa'],
						'Descripcion': this.$ml.get('description_plate_field'),						
						'Ejemplo': '',
						'Obligatorio': this.$ml.get('yes'),
						'Notas': ''

					},
					{
						'Campo': columns['Lista_ID'],
						'Descripcion': this.$ml.get('description_list_id_field'),
						'Ejemplo': '',
						'Obligatorio': this.$ml.get('no'),
						'Notas': ''
					},
					{
						'Campo': columns['Nombre'],
						'Descripcion': this.$ml.get('description_list_name_field'),
						'Ejemplo': '',
						'Obligatorio': this.$ml.get('no'),
						'Notas': this.$ml.get('do_not_fill_this_field')
					},
					{
						'Campo': columns['Moive'],
						'Descripcion': this.$ml.get('description_motive_field'),
						'Ejemplo': '',
						'Obligatorio': this.$ml.get('yes'),
						'Notas': ''
					},
					{
						'Campo': columns['Fecha_Creacion'],
						'Descripcion': this.$ml.get('field_generated_by_system'),
						'Ejemplo': '',
						'Obligatorio': this.$ml.get('no'),
						'Notas': this.$ml.get('do_not_fill_this_field')
					},
					{
						'Campo': columns['Fecha_Actualizacion'],
						'Descripcion': this.$ml.get('field_generated_by_system'),
						'Ejemplo': '',
						'Obligatorio': this.$ml.get('no'),
						'Notas': this.$ml.get('do_not_fill_this_field')
					},
					// ...otros campos ejemplo...
				];
			},

			closeImportModal() {
				this.show.import_modal = false;
				this.info_import = null;
				this.import_selected_list = null;
			},

			async onFileSelected(file) {
				if (!file) {
					return; // No hay archivo seleccionado
				}
				
				this.validating_file = true;
				
				try {
					// Validar formato del archivo Excel inmediatamente
					const isValid = await this.validateExcelFormat(file);
					
					if (!isValid) {
						// Si el formato no es válido, limpiar el archivo seleccionado
						this.info_import = null;
					} else {
						// Mostrar mensaje de éxito si el formato es válido
						this.$EventBus.$emit('notifications_modal', {
							type: 'success',
							message: this.$ml.get('file_format_valid') || 'Archivo válido'
						});
					}
				} finally {
					this.validating_file = false;
				}
			},
			async importExcelFromModal() {
				if (!this.info_import || !this.import_selected_list) return;
				
				this.loading = true;
				const api = this.$URL + "/api/v1/listing_details/import";
				let formData = new FormData();
				formData.append("file", this.info_import);
				formData.append("type", this.head.title1);
				formData.append("listId", this.import_selected_list);
				try {
					const res = await this.$axios.post(api, formData);
					if (res && res.data) {
						this.$EventBus.$emit('notifications_modal', { type: 'updated' });
						this.closeImportModal();
						this.get_list();
					}
				} catch (er) {
					this.$EventBus.$emit('notifications_modal', { type: 'error', message: er });
				} finally {
					this.loading = false;
				}
			},

			async validateExcelFormat(file) {
				try {
					// Usar lazy loading de XLSX como en el resto del proyecto
					const xlsx = await import('xlsx');
					
					// Crear un lector de archivos
					const reader = new FileReader();
					
					return new Promise((resolve) => {
						reader.onload = (e) => {
							try {
								const data = new Uint8Array(e.target.result);
								const workbook = xlsx.read(data, { type: 'array' });
								
								// Obtener la primera hoja
								const firstSheetName = workbook.SheetNames[0];
								const worksheet = workbook.Sheets[firstSheetName];
								
								// Convertir a JSON para analizar la estructura
								const jsonData = xlsx.utils.sheet_to_json(worksheet, { header: 1 });
								
								if (jsonData.length === 0) {
									this.$EventBus.$emit('notifications_modal', {
										type: 'error',
										message: this.$ml.get('excel_validation_failed') + ': ' + this.$ml.get('excel_columns_required')
									});
									resolve(false);
									return;
								}
								
								// Verificar que todas las filas tengan exactamente 2 columnas
								const invalidRows = jsonData.filter(row => row.length !== 2);
								
								if (invalidRows.length > 0) {
									// Encontrar el número máximo de columnas para el mensaje de error
									const maxColumns = Math.max(...jsonData.map(row => row.length));
									
									this.$EventBus.$emit('notifications_modal', {
										type: 'error',
										message: this.$ml.get('excel_format_error') + ': ' + 
												this.$ml.get('excel_columns_found').replace('{0}', maxColumns)
									});
									resolve(false);
									return;
								}
								
								// Si llegamos aquí, el formato es correcto
								resolve(true);
								
							} catch (error) {
								console.error('Error validating Excel format:', error);
								this.$EventBus.$emit('notifications_modal', {
									type: 'error',
									message: this.$ml.get('excel_validation_failed') + ': ' + error.message
								});
								resolve(false);
							}
						};
						
						reader.onerror = () => {
							this.$EventBus.$emit('notifications_modal', {
								type: 'error',
								message: this.$ml.get('excel_validation_failed') + ': Error reading file'
							});
							resolve(false);
						};
						
						// Leer el archivo como array buffer
						reader.readAsArrayBuffer(file);
					});
					
				} catch (error) {
					console.error('Error in validateExcelFormat:', error);
					this.$EventBus.$emit('notifications_modal', {
						type: 'error',
						message: this.$ml.get('excel_validation_failed') + ': ' + error.message
					});
					return false;
				}
			},

		}, // methods

		mounted(){
			let temp_bus = 'notifications_modal' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) => {
				if (action) {
					this.del(this.info_item);
				}
			})
		}, // mounted
		
		beforeDestroy(){
			let vn = this;
			for(let iter in vn.bus){
				if (vn.bus[iter]) {
					EventBus.$off(iter, vn.bus[iter]);
				}
			}
			// console.log("close bus listing details");
		}, // beforeDestroy

	}; // export default
</script>

<style scoped>
.position-relative {
	position: relative;
}

.table-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.7);
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
}

.overlay-content {
	color: white;
	padding: 20px;
}

.overlay-content h6,
.overlay-content p {
	color: white !important;
}

.export-btn-text {
    font-size: 16px;
    font-family: inherit;
    color: #4caf50;
    font-weight: 400;
    letter-spacing: 0.5px;
}
</style>